import { Button } from '@ya.praktikum/react-developer-burger-ui-components';
import { withButton } from '../../hocs/with-button/with-button';

export const ButtonWithChildren = withButton(Button);
